import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/pacientes/loading";
import { PatientList } from "@/client/modules/pacientes/patient-list";
import { TrashSection } from "@/client/modules/pacientes/trash-section";

export const Route = createFileRoute("/app/pacientes/")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("pacientes", "page", {})),
  head: () => pageHead("Pacientes"),
  pendingComponent: Loading,
  component: PacientesPage,
});

function PacientesPage() {
  const { data } = useApiSuspenseQuery("pacientes", "page", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Pacientes" description="Cadastro de pacientes da clínica." />
      <PatientList patients={data.patients} insurances={data.insurances} isAdmin={data.isAdmin} />
      <TrashSection items={data.trashed} />
    </div>
  );
}
